import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1rem',
    marginLeft: 0,
    alignItems: 'center',
});
